import React from 'react'

import Link from '../../Link'
import { FooterLegalFootnotes } from '../FooterLegalFootnotes'
import { SocialMediaMenu } from '../SocialMediaMenu'

import logo from '../../../../img/logo-designs-for-health-textonly.svg'

export const FooterPrint: React.FC = () => (
  <footer className="flex pt-5 py-7 px-12 bg-brand-navy w-full text-brand-white min-h-0 font-gotham justify-center">
    <div className="w-full">
      <section className="flex justify-between items-center mb-2">
        <Link to="/" className="w-auto h-auto">
          <img src={logo} alt="Designs for Health" className="h-5" />
        </Link>

        <SocialMediaMenu isPrinting />
      </section>
      <FooterLegalFootnotes isPrinting />
    </div>
  </footer>
)
